module.exports = __webpack_public_path__ + "img/placeholder_lote_hotel_ttttt.a6e81657.png";